import React from "react";

const style = {
    height: '2px',
    marginLeft: `auto`,
    marginRight: `auto`,
    background: '#DDDDDD'
};

const Divider = () => {
    return ( <div className="full" style={style}></div> )
};

export default Divider;